import axios from 'axios'

export default {
    namespaced: true,
    state: {
        childcareApplicationChecklistStatuses: [],
    },
    mutations: {
        SET_CHILDCARE_APPLICATION_CHECKLIST_STATUSES(state, payload) {
            state.childcareApplicationChecklistStatuses = payload;
        },
    },
    actions: {
        async FetchChildcareApplicationChecklistStatuses({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/checklist/statuses/list`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_CHILDCARE_APPLICATION_CHECKLIST_STATUSES', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchChildcareApplicationChecklistStatuses: ${error.message}`));
            });
        },
    },
    getters: {
        ChildcareApplicationChecklistStatuses(state) { return state.childcareApplicationChecklistStatuses; },
    }
}
